import React, { useEffect, useState } from 'react'; 
import styles from './../../Assets/CSS/Register.module.css';
import inputStyles from './../../Assets/CSS/Input.module.css';
import axios from 'axios';
import { BASE_URL } from './../../Environment';
import { useNavigate } from 'react-router-dom';
import { BlueButton } from './../../Components/Button';
import { toast } from 'react-toastify'; 
import { BsYoutube } from 'react-icons/bs'; 
 
function Register() {
    const navigate = useNavigate();   
    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState(''); 
    const [dob, setDoB] = useState('');   
    const [blood_group, setBloodGroup] = useState('');   
    const [pincode, setPincode] = useState('');
    const [house_no, setHouseNo] = useState('');
    const [road_name, setRoadName] = useState(''); 
    const [district, setDistrict] = useState('');
    const [state, setState] = useState('');
    const [country, setCountry] = useState(''); 
    const [landmark, setLandmark] = useState('');  
    const [referral_code, setReferralCode] = useState('');
    const [referralInfo, setReferralInfo] = useState(null);
    const [isCheckingReferral, setIsCheckingReferral] = useState(false); 
    const [password, setPassword] = useState('');
    const [confirm_password, setConfirmPassword] = useState('');
    useEffect(() => {
        document.title = 'Infomart | User Register';
    }, []);
    const checkReferralCode = async (code) => {
        if (!code.trim()) { setReferralInfo(null); return; }
        setIsCheckingReferral(true);
        try {
            const response = await axios.get(`${BASE_URL}/check-referral/${code}`);
            if (response.data.success) {
                setReferralInfo({ exists: true, name: response.data.name, type: response.data.type });
            } else {
                setReferralInfo({ exists: false });
            }
        } catch (error) { setReferralInfo({ exists: false }); }
        finally { setIsCheckingReferral(false); }
    };
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (referral_code) checkReferralCode(referral_code);
            else setReferralInfo(null);
        }, 500);
        return () => clearTimeout(timeoutId);
    }, [referral_code]); 
    const handleRegister = async () => {
        setIsLoading(true);
        if (password === confirm_password) {
            await axios.post(`${BASE_URL}/user/register`, { referral_code, name, email, phone, dob, blood_group, house_no, road_name, pincode, district, state, country, landmark, password }, {
                headers: {     
                    'Content-Type': 'application/json'
                } 
            }).then((res) => {
                toast.success(res.data.msg, { autoClose: 3000 });
                setIsLoading(false);
                navigate('/user/login'); 
            }).catch((res) => {
                toast.error(res.response.data.msg, { autoClose: 3000 });
                setIsLoading(false);
            });
        } else {
            toast.error('Password and Confirm Password does not match.', { autoClose: 3000 });
            setIsLoading(false); 
        }
    }
    const handleDateChange = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, '');
        if (value.length > 8) {
            value = value.substring(0, 8);
        }
        if (value.length >= 5) {
            value = value.replace(/^(\d{2})(\d{2})(\d{0,4})$/, '$1/$2/$3');
        } else if (value.length >= 3) {
            value = value.replace(/^(\d{2})(\d{0,2})$/, '$1/$2');
        }
        setDoB(value);
    }; 
    const handlePincode = (e) => {
        let value = e.target.value;
        setPincode(value); 
        if (value.length == 6) {
            axios.get(`${BASE_URL}/pincode/${value}`).then((res) => { 
                setDistrict(res.data[0].PostOffice[0].District);
                setState(res.data[0].PostOffice[0].State);
                setCountry(res.data[0].PostOffice[0].Country); 
            });    
        }
    }   
    return (
        <div className="app"> 
            <div className="outlet">
                <div className={styles.individualFormContainer}>
                    <div className={styles.top}>
                        <div className="w-100">
                            <h4 className="text-left my-3">User Register</h4>
                            <a href="https://www.youtube.com/watch?v=KkGFrVyBC54" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 13, color: 'red', textDecoration: 'none', marginBottom: 10 }}>
                                <BsYoutube size={18} /> Watch Form Fill-up Tutorial
                            </a> 
                        </div> 
                    </div> 
                    <div style={{ position: 'relative', width: '100%' }}>
                        <input type="text" className={inputStyles.input} placeholder="Enter Referral Code (Optional)" value={referral_code} onChange={e => setReferralCode(e.target.value.toUpperCase())} />
                        {(isCheckingReferral || referralInfo) && (
                            <div style={{
                                marginTop: '8px', padding: '8px 12px', borderRadius: '4px', fontSize: '14px',
                                display: 'flex', alignItems: 'center', gap: '8px',
                                backgroundColor: isCheckingReferral ? '#f8f9fa' : referralInfo?.exists ? '#d4edda' : '#f8d7da',
                                border: `1px solid ${isCheckingReferral ? '#dee2e6' : referralInfo?.exists ? '#c3e6cb' : '#f5c6cb'}`,
                                color: isCheckingReferral ? '#6c757d' : referralInfo?.exists ? '#155724' : '#721c24'
                            }}>
                                {isCheckingReferral ? (
                                    <>
                                        <div style={{ width: '16px', height: '16px', border: '2px solid #6c757d', borderTop: '2px solid transparent', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
                                        Checking referral code...
                                    </>
                                ) : referralInfo?.exists ? (
                                    <>
                                        <span style={{ color: '#28a745', fontWeight: 'bold' }}>✓</span>
                                        {referralInfo.type} found: <strong>{referralInfo.name}</strong>
                                    </>
                                ) : (
                                    <>
                                        <span style={{ color: '#dc3545', fontWeight: 'bold' }}>✗</span>
                                        Invalid referral code
                                    </>
                                )}
                            </div>
                        )}
                    </div> 
                    <div id="input-city-a" className={styles.row}>
                        <input type="text" className={inputStyles.input} placeholder="Enter Your Full Name *" onChange={e => setName(e.target.value)} />
                        <input type="email" className={inputStyles.input} placeholder="Enter Email ID *" onChange={e => setEmail(e.target.value)} /> 
                    </div>
                    <div id="input-city-a" className={styles.row}> 
                        <input type="number" className={inputStyles.input} placeholder="Enter Phone No. *" onChange={e => setPhone(e.target.value)} />
                        <input type="text" className={inputStyles.input} value={dob} placeholder="Enter Date of Birth (DD/MM/YYYY) *" onChange={handleDateChange} /> 
                        <select className={inputStyles.dropdown} onChange={e => setBloodGroup(e.target.value)}> 
                            <option value="" selected disabled>Select Blood Group</option>
                            <option value="A+">A+</option>  
                            <option value="A-">A-</option>
                            <option value="B+">B+</option>
                            <option value="B-">B-</option>
                            <option value="AB+">AB+</option>
                            <option value="AB-">AB-</option>
                            <option value="O+">O+</option>
                            <option value="O-">O-</option>  
                        </select>    
                    </div> 
                    <div id="not-row-b" className={styles.row}> 
                        <input type="text" className={inputStyles.input} placeholder="Enter House No." onChange={e => setHouseNo(e.target.value)} />
                        <input type="text" className={inputStyles.input} placeholder="Enter Road Name *" onChange={e => setRoadName(e.target.value)} />
                    </div>   
                    <div id="not-row-b" className={styles.row}>
                        <input type="number" className={inputStyles.input} placeholder="Enter Pincode *" onChange={handlePincode} />  
                        <input type="text" className={inputStyles.input} value={district} placeholder="Enter District *" onChange={e => setDistrict(e.target.value)} />
                    </div> 
                    <div id="not-row-b" className={styles.row}>
                        <input type="text" className={inputStyles.input} value={state} placeholder="Enter State *" onChange={e => setState(e.target.value)} />
                        <input type="text" className={inputStyles.input} value={country} placeholder="Enter Country *" onChange={e => setCountry(e.target.value)} /> 
                    </div>   
                    <textarea className={inputStyles.input} placeholder="Enter Landmark (Optional)" onChange={e => setLandmark(e.target.value)} />  
                    <div id="input-city-a" className={styles.row}> 
                        <input type="password" className={inputStyles.input} placeholder="Enter Password *" onChange={e => setPassword(e.target.value)} />
                        <input type="password" className={inputStyles.input} placeholder="Enter Confirm Password *" onChange={e => setConfirmPassword(e.target.value)} />
                    </div>
                    <div className={styles.checkboxSection}>
                        <input type="checkbox" className={styles.checkbox} checked />
                        <div>
                            Agree&nbsp;
                            <span className={styles.colorTxt}>
                                <a href="/terms-conditions" target="_blank">Terms & Conditions</a> 
                            </span> 
                        </div>
                    </div>
                    <div className="mt-5">
                        <BlueButton title={isLoading ? "Loading..." : "Register"} onClick={() => handleRegister()} />
                    </div>
                </div>
            </div> 
        </div>
    );
}

export default Register; 